import { render, staticRenderFns } from "./__MasterSimpleSection.vue?vue&type=template&id=c6839336&scoped=true&"
import script from "./__MasterSimpleSection.vue?vue&type=script&lang=js&"
export * from "./__MasterSimpleSection.vue?vue&type=script&lang=js&"
import style0 from "./__MasterSimpleSection.vue?vue&type=style&index=0&id=c6839336&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6839336",
  null
  
)

export default component.exports